import axios from "axios";
import { API_BASEURL } from "../config/StaticConfig";
import { Token } from "./session";

export async function getSubgraphLogs(cluster: string, subgraphDeploymentId: string, range?: string) {
  const result = await axios.get(`${API_BASEURL}/subgraph/logs/${cluster}/${subgraphDeploymentId}/export`, {
    responseType: "stream",
    headers: {
      Authorization: Token.has() ? `Bearer ${Token.get()}` : "",
    },
    params: {
      range,
    },
  });

  const url = window.URL.createObjectURL(new Blob([result.data]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "export.csv");
  document.body.appendChild(link);
  link.click();
}
